import { render, staticRenderFns } from "./RsaGestioneOspitiSchedaOspiteViewPage.vue?vue&type=template&id=e7775506"
import script from "./RsaGestioneOspitiSchedaOspiteViewPage.vue?vue&type=script&lang=js"
export * from "./RsaGestioneOspitiSchedaOspiteViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports